import { getUrlParameter, isEmpty, isNumber, isUndefined } from '~/utils';
import { URL_PARAMETER } from '~/constants';

/**
 * 是否为成员邀请模式
 * 1）通讯录邀请成员
 * 2）互联组织批量导入邀请成员
 */
export const isInvitationMode = !isEmpty(window.jdy_invitation_info);
export const isLoginInvitationMode = !isEmpty(getUrlParameter(URL_PARAMETER.INVITED_BY));
export const defaultPhone = getUrlParameter(URL_PARAMETER.PHONE);
export const defaultEmail = getUrlParameter(URL_PARAMETER.EMAIL);
export const defaultNickname = getUrlParameter(URL_PARAMETER.NICKNAME);

/**
 * 是否为指定账号邀请
 */
export const isAccountInvitation = isInvitationMode && !!(defaultPhone || defaultEmail);

/**
 * 是否为公开链接邀请
 */
export const isPublicInvitation = getUrlParameter(URL_PARAMETER.IS_PUBLIC) === 'true';

/**
 * 获取用于注册接口接口 POST /register 鉴权的相关参数
 * 目前用于独享版邀请注册场景
 */
export const getAuthParamsOnRegister = () => {
    let authParams: {
        is_public?: boolean;
        invited_by?: string;
        invitation_token?: string;
        dept_no?: number;
    } = {};

    if (isInvitationMode) {
        const { isPublic, invitedBy, token, deptNo } = window.jdy_invitation_info || {};
        if (!isUndefined(isPublic)) {
            authParams = {
                ...authParams,
                is_public: isPublic
            };
        }
        if (invitedBy) {
            authParams = {
                ...authParams,
                invited_by: invitedBy.corp_id
            };
        }
        if (!isEmpty(token)) {
            authParams = {
                ...authParams,
                invitation_token: token
            };
        }
        if (isNumber(deptNo)) {
            authParams = {
                ...authParams,
                dept_no: deptNo
            };
        }
    }
    return authParams;
};
